import {
  call,
  put,
  takeLatest,
} from "@redux-saga/core/effects";
import * as Services from "../../Services/";
import {PaymentTypeActions} from "./Slice";
import {GET_PAYMENT_TYPES} from "./Types";
import {comparator, toast} from "../../Utils/Utils";

function* getPaymentTypes() {
  try {
    const res = yield call(Services.getPaymentTypes);
    if (!res?.results) {
      throw Error('There was an error.');
    } else {
      const paymentTypes = res.results;
      paymentTypes.sort(comparator());
      yield put(PaymentTypeActions.setPaymentTypes(paymentTypes));
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
  }
}

export function* paymentTypesSaga() {
  yield takeLatest(GET_PAYMENT_TYPES, getPaymentTypes);
}
